namespace Ir.Components.Workbook.Settings.Items.HtmlEditorSetting {
    interface IViewModel {
        popupConfig: DevExpress.ui.dxPopup.Properties;
        htmlEditorConfig: DevExpress.ui.dxHtmlEditor.Properties;

        quill: any;
        defaultLinkDisabled: KnockoutObservable<boolean>;
    }

    export interface IHtmlEditorSettings {
        value: string;
        backgroundColor?: string;
        onSaving: (value: string, height: number) => boolean;
        menuOptions?: Array<any>,

        linkButton?: any;
    }

    let settings: IHtmlEditorSettings;
    let popupComponent: DevExpress.ui.dxPopup;
    let htmlEditorComponent: DevExpress.ui.dxHtmlEditor;
    export function getViewModel(this: IViewModel, params: any) {
        let self = this;

        this.defaultLinkDisabled = ko.observable(false);
        this.popupConfig = {
            title: "Edit Content",
            showTitle: true,
            width: 1300,
            height: 600,
            visible: false,
            resizeEnabled: true,
            toolbarItems: [{
                widget: 'dxButton',
                toolbar: 'bottom',
                location: 'after',
                options: {
                    icon: 'save',
                    stylingMode: 'contained',
                    type: 'default',
                    text: 'Save',
                    onClick(e) {
                        let bounds = htmlEditorComponent.getBounds(0, htmlEditorComponent.getLength());
                        let height = ((bounds.height + bounds.top) * 0.264583) + 2;
                        if (settings.onSaving(htmlEditorComponent.option("value"), height)) {                            
                            popupComponent.hide();
                        }
                    }
                }
            }, {
                widget: 'dxButton',
                toolbar: 'bottom',
                location: 'after',
                options: {
                    text: 'Close',
                    icon: 'remove',
                    stylingMode: 'outlined',
                    type: 'normal',
                    onClick() {
                        popupComponent.hide();
                    }
                }
            }],
            onShowing(e) {
                htmlEditorComponent.option("toolbar.items", getButtons(self));

                applyBackgroundColor(e.element);
            },
            onInitialized: function (e) {
                popupComponent = e.component;
                popupComponent.show();
            },
        };

        this.htmlEditorConfig = {
            value: settings.value,
            height: "100%",
            width: "100%",
            imageUpload: {
                tabs: ['file'],
                fileUploadMode: 'base64'
            },
            mediaResizing: {
                enabled: true,
            },
            stylingMode: "underlined",
            toolbar: {
                items: [],
                multiline: true
            },
            onInitialized(e) {
                htmlEditorComponent = e.component;

                //https://supportcenter.devexpress.com/ticket/details/t954837/htmleditor-how-to-define-a-prefix-for-a-link
                const Link = htmlEditorComponent.get("formats/link");
                class PrefixLink extends Link {
                    static sanitize(url) {
                        return super.sanitize(url, this.PROTOCOL_WHITELIST) ? (url.includes('https://') ? url : `https://${url}`) : this.SANITIZED_URL;
                    }
                }
                htmlEditorComponent.register({ "formats/link": PrefixLink });
            },
            onContentReady(e) {
                applyBackgroundColor(e.element);

                self.quill = e.component.getQuillInstance();

                self.quill.on('selection-change', function (range) {
                    const toolbar = $('.dx-htmleditor-toolbar');
                    const linkButton = $('.dx-button[aria-label="Add Link"]', toolbar);
                    const customLinkButton = $('.dx-button[aria-label="ms ir-add-link"]', toolbar);
                    let linkDisabled = false;
                    let customLinkDisabled = false;
                    if (linkButton && customLinkButton) {
                        customLinkButton.removeClass('dx-state-selected');
                        if (range) {
                            const format = self.quill.getFormat(range);
                            if (format.link) {
                                if (format.link.includes("[Link")) {
                                    linkDisabled = true;
                                    customLinkButton.addClass('dx-state-selected');
                                }
                                else {
                                    customLinkDisabled = true;
                                }
                            }
                        }
                                            
                        linkButton.removeClass("dx-state-disabled");
                        if (linkDisabled) {
                            linkButton.addClass("dx-state-disabled");
                            linkButton.removeClass('dx-state-selected');
                        }

                        customLinkButton.removeClass("dx-state-disabled");
                        if (customLinkDisabled) {
                            customLinkButton.addClass("dx-state-disabled");
                            customLinkButton.removeClass('dx-state-selected');
                        }
                    }
                });
            },
        }
    }

    function applyBackgroundColor(context) {
        if (settings.backgroundColor && settings.backgroundColor.toLowerCase() !== "transparent") {
            $(".dx-htmleditor-content", context).css("background-color", settings.backgroundColor);
        }
        else {
            $(".dx-htmleditor-content", context).css("background-color", "");
        }
    }

    function getButtons(self: IViewModel) {
        let items = [];

        if (settings.menuOptions && settings.menuOptions.length) {
            items.push({
                widget: "dxMenu",
                options: {
                    dataSource: ko.computed(function () {
                        return settings.menuOptions;
                    }),
                    hideSubmenuOnMouseLeave: false,
                    displayExpr: 'name',
                    onItemClick(e) {
                        let item: VariableHtmlEditor = e.itemData;
                        if (item.items.length === 0) {
                            const newPosition = htmlEditorComponent.getSelection(true);
                            htmlEditorComponent.insertText(newPosition.index, item.tag, undefined);
                        }
                    },
                    visible: ko.computed(function () { return settings.menuOptions.length > 0; })
                }
            });
        }

        if (settings.linkButton) {
            items.push(settings.linkButton);
        }

        if (items.length) {
            items.push('separator');
        }

        addDefaultButtons(items);

        return items;
    }

    function addDefaultButtons(items: Array<any>) {
        let defaultItems = ['undo', 'redo', 'separator',
            {
                name: 'size',
                acceptedValues: ['8pt', '10pt', '12pt', '14pt', '18pt', '24pt', '36pt'],
                options: { inputAttr: { 'aria-label': 'Font size' } },
            },
            {
                name: 'font',
                acceptedValues: ['Arial', 'Courier New', 'Georgia', 'Impact', 'Lucida Console', 'Tahoma', 'Times New Roman', 'Verdana'],
                options: { inputAttr: { 'aria-label': 'Font family' } },
            },
            'separator', 'bold', 'italic', 'strike', 'underline', 'separator',
            'alignLeft', 'alignCenter', 'alignRight', 'alignJustify', 'separator',
            'orderedList', 'bulletList', 'separator',
            'color', 'background', 'separator', 'link', 'image', 'separator',
            //'clear', 'codeBlock', 'blockquote', 'separator',
            'insertTable', 'deleteTable',
            'insertRowAbove', 'insertRowBelow', 'deleteRow',
            'insertColumnLeft', 'insertColumnRight', 'deleteColumn'];

        items.push(...defaultItems);
    }

    export function getCustomLink(): { link: string, text: string, range: any } {
        const quill = htmlEditorComponent.getQuillInstance();
        let range = quill.getSelection();

        const format = quill.getFormat(range);
        if (format && format.link) {
            let isCustomLink = format.link.includes("[Link");
            if (isCustomLink) {
                const [leaf, offset] = quill.getLeaf(range.index);
                const linkNode = leaf?.domNode?.parentNode;
                const text =  linkNode.innerText;

                const fullText = quill.getText();
                const linkIndex = fullText.indexOf(text);

                range = {
                    index: linkIndex,
                    length: text.length
                };

                return { link: format.link, text: text, range: range };
            }
        }

        return null;
    }

    export function show(options: IHtmlEditorSettings) {
        settings = options;

        if (popupComponent == null) {
            let $popup = $(`<html-editor-setting></html-editor-setting>`);
            $popup.appendTo('body');
            ko.applyBindings({ }, $popup.get(0));
        }
        else {
            htmlEditorComponent.option("value", settings.value);
            popupComponent.show();
        }
    }

    export function insertLink(name: string, href: string){
        if (htmlEditorComponent) {
            const newPosition = htmlEditorComponent.getSelection(true);
            htmlEditorComponent.insertText(newPosition.index, name, "link", {
                href: href
            });
        }
    }

    export function replaceLink(range, newName: string, newHref: string) {
        if (htmlEditorComponent) {
            htmlEditorComponent.delete(range.index, range.length);
            htmlEditorComponent.insertText(range.index, newName, "link", {
                href: newHref
            });
        }
    }
}